/**
 * @private
 */
const SPACES = /\r?\n[\t ]+/;
const LINES = /\r?\n/;
const JSON = /json/;

/**
 * Converts the plain text of headers into an array of headers.
 */
const processHeaders = {
  parse: function parse(rawHeaders) {
    // @see https://tools.ietf.org/html/rfc7230#section-3.2
    return rawHeaders.trim().replace(SPACES, ' ').split(LINES);
  },
  hasJSON: function hasJSON(headers) {
    return headers.some(h => JSON.test(h));
  },
  from: function fromXHR(xhr) {
    return this.parse(xhr.getAllResponseHeaders());
  },
};

export default processHeaders;
